import { cloneDeep, orderBy, sortBy } from 'lodash'
import { allUnitArr } from './enum'

let _this = this
function bindThis(val) {
	_this = val
}
// 识别客观题
function recognizeObjective(_this, val, tempObjectTopic, titleDirection, fillDirection) {
	// 题号为竖向 填涂方向为横向 结果值
	function titleVfillH(originBox, leftTopRect, xInterval, yInterval, standColArr, tempObjectTopic) {
		// 获取标准行,并设置ABCD
		let standFirstRow = []
		originBox.forEach(res => {
			if (res.y >= leftTopRect.y - yInterval && res.y <= leftTopRect.y + yInterval) standFirstRow.push(res)
		})
		// 获取标准行
		standFirstRow = orderBy(standFirstRow, ['x'], ['asc'])

		let intervalRatioList = []
		for (let i = 1; i < standFirstRow.length - 1; i++) {
			if ((standFirstRow[i].x - standFirstRow[i - 1].x) / (standFirstRow[i + 1].x - standFirstRow[i].x) > 1.5) intervalRatioList.push(standFirstRow[i])
		}
		intervalRatioList.unshift({ x: 0 })

		let lastBox = cloneDeep(originBox[originBox.length - 1])
		lastBox.x += 150
		intervalRatioList.push(lastBox)
		let verticalObj = {}
		for (let ratio = 1; ratio < intervalRatioList.length; ratio++) {
			if (!verticalObj[intervalRatioList[ratio].x]) verticalObj[intervalRatioList[ratio].x] = []
			originBox.forEach(res => {
				if (res.x >= intervalRatioList[ratio - 1].x - xInterval && res.x <= intervalRatioList[ratio].x - xInterval) {
					verticalObj[intervalRatioList[ratio].x].push(res)
				}
			})
		}
		let allResultInfo = operateVertical(verticalObj, standColArr, tempObjectTopic, yInterval)
		return {
			resultBox: allResultInfo.resultBox,
			resultTitle: allResultInfo.resultTitle
		}
	}
	//设置竖直方向数据
	function operateVertical(verticalObjList, standColArr, tempObjectTopic, yInterval) {
		let resultObj = [],
			resultTitle = [],
			concludeObj = {},
			topicIndex = -1
		for (let key in verticalObjList) {
			if (!concludeObj[key]) concludeObj[key] = {}
			verticalObjList[key].forEach(res => {
				standColArr.forEach(responce => {
					if (!concludeObj[key][responce.y]) concludeObj[key][responce.y] = []
					if (res.y >= responce.y - yInterval * 0.8 && res.y <= responce.y + yInterval) {
						concludeObj[key][responce.y].push(res)
					}
				})
			})
		}
		for (let key in concludeObj) {
			for (let box in concludeObj[key]) {
				if (concludeObj[key][box].length === 0) {
					delete concludeObj[key][box]
				}
			}
		}

		let objKeyList = Object.keys(verticalObjList)
			.map(res => Number(res))
			.sort((a, b) => a - b)
		objKeyList.forEach(keys => {
			let resuBox = sortBy(concludeObj[keys.toString()], ele => ele[0].y)
			for (let box in resuBox) {
				topicIndex += 1
				if (tempObjectTopic[topicIndex]) {
					let rowBox = orderBy(resuBox[box], ['x'], ['asc'])
					rowBox.forEach((response, respIndex) => {
						response.n = tempObjectTopic[topicIndex].pkId
						response.m = tempObjectTopic[topicIndex].bigTopic
						response.i = tempObjectTopic[topicIndex].smallTopic
						response.v = allUnitArr[respIndex]
						resultObj.push(response)
					})
					let first = cloneDeep(rowBox[0])
					first.x -= 70
					first.v = tempObjectTopic[topicIndex].smallTopic
					resultTitle.push(first)
				}
			}
		})
		return { resultBox: resultObj, resultTitle }
	}

	// 题号为横向 填涂方向为横向 结果值
	function titleHfillH(standColArr, originBox, yInterval, tempObjectTopic) {
		let horizontalObj = [],
			resultBox = []
		standColArr.forEach(res => {
			if (!horizontalObj[res.y]) horizontalObj[res.y] = []
			originBox.forEach(responce => {
				if (responce.y >= res.y - yInterval && responce.y <= res.y + yInterval) {
					horizontalObj[res.y].push(responce)
					horizontalObj[res.y] = orderBy(horizontalObj[res.y], ['x'], ['asc'])
				}
			})
		})

		let allResultInfo = operateHorizontal(horizontalObj, tempObjectTopic)
		for (let key in allResultInfo.resultBox) {
			for (let curKey in allResultInfo.resultBox[key]) {
				resultBox = [...resultBox, allResultInfo.resultBox[key][curKey]]
			}
		}
		return {
			resultBox: resultBox.flat(Infinity),
			resultTitle: allResultInfo.resultTitle
		}
	}
	// 设置水平方向数据
	function operateHorizontal(horizontalObj, tempObjectTopic) {
		let resultHorizonalObj = {},
			restltHorizonalTitle = [],
			boxIndex = 0,
			topicIndex = 0,
			boxArr = []
		for (let val in horizontalObj) {
			horizontalObj[val].forEach(res => {
				boxIndex += 1
				boxArr.push(res)
				if (boxIndex === tempObjectTopic[topicIndex].num) {
					let orderedBoxArr = orderBy(boxArr, ['x'], ['asc'])
					orderedBoxArr.forEach((res, index) => {
						res.n = tempObjectTopic[topicIndex].pkId
						res.m = tempObjectTopic[topicIndex].bigTopic
						res.i = tempObjectTopic[topicIndex].smallTopic
						res.v = allUnitArr[index]
					})
					let first = cloneDeep(orderedBoxArr[0])
					first.x -= 50
					first.v = tempObjectTopic[topicIndex].smallTopic
					restltHorizonalTitle.push(first)
					resultHorizonalObj[tempObjectTopic[topicIndex].smallTopic] = orderedBoxArr
					boxIndex = 0
					topicIndex += 1
					boxArr = []
				}
			})
		}
		return { resultBox: resultHorizonalObj, resultTitle: restltHorizonalTitle }
	}

	// 题号为水平 填土方向为竖直
	function titleHFillV(standRowArr, originBox, xInterval, tempObjectTopic) {
		let resultObj = {},
			resultTitle = []
		standRowArr.forEach((res, index) => {
			if (!resultObj[res.x]) resultObj[res.x] = []
			originBox.forEach(responce => {
				if (responce.x <= res.x + xInterval && responce.x >= res.x - xInterval) {
					responce.n = tempObjectTopic[index].pkId
					responce.m = tempObjectTopic[index].bigTopic
					responce.i = tempObjectTopic[index].smallTopic
					resultObj[res.x].push(responce)
				}
			})
			const cur = cloneDeep(res)
			cur.y -= 50
			cur.v = tempObjectTopic[index].smallTopic
			resultTitle.push(cur)
		})
		let resultBox = []
		for (const key in resultObj) {
			let cur = cloneDeep(resultObj[key])
			cur = orderBy(cur, ['y'], ['asc'])
			cur.map((response, index) => (response.v = allUnitArr[index]))
			resultBox.push(...cur)
		}
		return { resultBox: resultBox, resultTitle }
	}
	//---------------------------------------获取横向数据-----------------------------------
	let originBox = orderBy(val, ['x'], ['asc'])
	let getOriginBox = originBox.slice(0, 6)
	let leftTopRect = orderBy(getOriginBox, ['y'], ['asc'])[0]
	let yInterval = originBox[0].h
	let xInterval = originBox[0].w
	let standColArr = [],
		standRowArr = []
	// 获取最左边一列 作为标准列 y 轴
	originBox.forEach(resp => {
		if (resp.x >= leftTopRect.x - xInterval && resp.x <= leftTopRect.x + xInterval) standColArr.push(resp)
		if (resp.y >= leftTopRect.y - yInterval && resp.y <= leftTopRect.y + yInterval) standRowArr.push(resp)
	})
	//获取标准列   y
	standColArr = orderBy(standColArr, ['y'], ['asc'])
	//---------------------------------------题号为横向 填涂方向为横向------------------------------------------------------------------
	if (titleDirection === 'H' && fillDirection === 'H') {
		return titleHfillH(standColArr, originBox, yInterval, tempObjectTopic)
	}

	//---------------------------------------题号为横向 填涂方向为竖向-------------------------------------------------------------------
	if (titleDirection === 'H' && fillDirection === 'V') {
		return titleHFillV(standRowArr, originBox, xInterval * 0.6, tempObjectTopic)
	}

	//---------------------------------------题号为竖向 填涂方向为横向-------------------------------------------------------------------
	if (titleDirection === 'V' && fillDirection === 'H') {
		return titleVfillH(originBox, leftTopRect, xInterval, yInterval, standColArr, tempObjectTopic)
	}
}
//识别 考号
function recognizeExamNo(_this, val, posInfo = [], isFresh = false) {
	let box = []
	if (val && val.length > 0) {
		let setaVal = []
		val.forEach(resp => {
			setaVal.push({
				c: resp.C || resp.c,
				h: resp.H || resp.h,
				i: resp.I || resp.i,
				r: resp.R || resp.r,
				w: resp.W || resp.w,
				x: resp.X || resp.x,
				y: resp.Y || resp.y,
				v: resp.v
			})
		})
		if (setaVal.length % 10 !== 0) {
			_this.addDropRect(...posInfo, setaVal)
			return false
		}
		let yArr = []
		setaVal.forEach(res => yArr.push(res.y))
		let yMin = Math.min(...yArr)
		let yMax = Math.max(...yArr)
		let height = setaVal[0].h
		let yInterval = (yMax - yMin - height * 9) / 9
		let heightInterval = (yMax - yMin + yInterval + height) / 10

		let yHeightList = []
		for (var i = 0; i < 10; i++) {
			yHeightList.push(Math.round(heightInterval * (i + 1) + height))
		}
		yHeightList.unshift(0)
		let intervalH = height
		let listObj = {}
		for (let i = 0; i < 10; i++) {
			setaVal.forEach(res => {
				if (res.y >= yHeightList[i] - intervalH && res.y <= yHeightList[i + 1] - intervalH) {
					if (!listObj[yHeightList[i]]) listObj[yHeightList[i]] = []
					listObj[yHeightList[i]].push(Object.assign({}, res, { v: i }))
				}
			})
		}
		box = Object.values(listObj).flat(Infinity)
	}
	if (isFresh) {
		return box
	} else {
		_this.addDropRect(...posInfo, box)
	}
}
// 针对复制初始化题号
function setHandleCopyInit(startVal, topicTitle, box) {
	if (!startVal) {
		this.$message.error('请填写初始题号')
		return
	}
	let colBoxIndex = 0
	topicTitle.forEach((res, index) => {
		if (startVal === res.smallTopic) colBoxIndex = index
	})
	let orderedBox = orderBy(box, ['x'], ['asc'])
	let firstBox = orderedBox[0]
	let colBox = []
	orderedBox.forEach(res => {
		if (res.x >= firstBox.x - firstBox.w && res.x <= firstBox.x + firstBox.w) {
			colBox.push(res)
		}
	})
	colBox = orderBy(colBox, ['y'], ['asc'])
	let colBoxLen = colBox.length
	let resTopTit = topicTitle.slice(colBoxIndex, colBoxIndex + colBoxLen)
	let resObj = {}
	let titleObj = []
	colBox.forEach((res, index) => {
		if (!resObj[index]) resObj[index] = []
		orderedBox.forEach(resp => {
			if (resp.y >= res.y - firstBox.y && resp.y <= res.y + firstBox.y && resTopTit[index]) {
				resp.n = resTopTit[index].pkId
				resp.m = resTopTit[index].bigTopic
				resp.v = allUnitArr[resObj[index].length]
				resObj[index].push(resp)
			}
		})
	})
	let realResObj = []
	resTopTit.forEach((res, index) => {
		resObj[index].forEach(ele => {
			ele.n = res.pkId
			ele.m = res.bigTopic
		})
		let orderRow = orderBy(resObj[index], ['x'], ['asc'])
		let cloneRow = cloneDeep(orderRow)
		let first = cloneRow[0]
		first.x -= 50
		first.v = res.smallTopic
		titleObj.push(first)
		let last = cloneRow[cloneRow.length - 1]
		if (res.num === resObj[index].length) {
			realResObj = [...realResObj, ...resObj[index]]
		} else if (res.num > resObj[index].length) {
			let sum = res.num - resObj[index].length
			let interval = orderRow[1].x - orderRow[0].x
			let stepSum = 0
			for (let i = 0; i < sum; i++) {
				last.x += interval
				last.n = res.pkId
				last.m = res.bigTopic
				last.v = allUnitArr[stepSum + resObj[index].length]
				resObj[index].push(last)
				realResObj = [...realResObj, ...resObj[index]]
				stepSum += 1
			}
		} else if (res.num < resObj[index].length) {
			let result = resObj[index].slice(0, res.num)
			realResObj = [...realResObj, ...result]
		}
	})
	return { box: realResObj, title: titleObj }
}
//复制
function setHandleVerticalCopyVal(comandVal, tempObjTopic, fillDirection) {
	let info = comandVal.val
	let title = JSON.parse(info.remarks).title
	if (!title) return false
	let lens = title.length
	let sortTitComd = sortBy(title, ele => Number(ele.n))
	let lastComd = sortTitComd[sortTitComd.length - 1]
	let resObjTopic = []
	tempObjTopic.forEach(res => {
		resObjTopic.push(...sortBy(res.val, ele => Number(ele.smallTopic)))
	})
	let opeIndex = 0
	resObjTopic.forEach((res, index) => {
		if (res.pkId === lastComd.n) {
			opeIndex = index
		}
	})
	let topic = resObjTopic.slice(opeIndex + 1, opeIndex + lens + 1)
	let box = JSON.parse(info.appendInfo).box
	let resObj = {}
	box.forEach(res => {
		if (!resObj[res.n]) {
			resObj[res.n] = [res]
		} else {
			resObj[res.n].push(res)
		}
	})
	let curIndex = -1
	let resTitle = []
	let curResObj = {}
	let interval = 0
	let size = ''
	let sizeNum = 0
	for (let key in resObj) {
		curIndex += 1
		let curRows = cloneDeep(resObj[key])
		let first = cloneDeep(curRows[0])
		if (!topic[curIndex]) {
			break
		}
		if (fillDirection === 'H') {
			first.x -= 50
		} else if (fillDirection === 'V') {
			first.y -= 70
		}
		first.v = topic[curIndex].smallTopic
		first.n = topic[curIndex].pkId
		first.m = topic[curIndex].bigTopic

		resTitle.push(first)
		let curRowLen = curRows.length
		if (fillDirection === 'H') {
			interval = curRows[1].x - curRows[0].x
		} else if (fillDirection === 'V') {
			interval = curRows[1].y - curRows[0].y
		}
		// 变少
		if (topic[curIndex].num < curRowLen) {
			curRows = curRows.slice(0, topic[curIndex].num)
			sizeNum = curRowLen - topic[curIndex].num
			size = 'short'
		}
		// 变多
		if (topic[curIndex].num > curRowLen) {
			let num = topic[curIndex].num - curRowLen
			for (var j = 0; j < num; j++) {
				;(function(j) {
					let sampleRect = cloneDeep(curRows[curRowLen - 1])
					if (fillDirection === 'H') {
						_this.$set(sampleRect, 'x', sampleRect.x + interval * (j + 1))
					} else if (fillDirection === 'V') {
						_this.$set(sampleRect, 'y', sampleRect.y + interval * (j + 1))
					}
					_this.$set(sampleRect, 'v', allUnitArr[curRowLen + j])
					curRows.push(sampleRect)
				})(j)
			}
			sizeNum = topic[curIndex].num - curRowLen
			size = 'long'
		}
		curRows.forEach(resp => {
			resp.n = topic[curIndex].pkId
			resp.m = topic[curIndex].bigTopic
		})
		curResObj[key] = curRows
	}
	if (size === 'short') info.areaMaxX -= sizeNum * interval
	if (size === 'long') info.areaMaxX += sizeNum * interval
	return { title: resTitle, box: Object.values(curResObj).flat(Infinity), OtherInfo: info }
}

export { recognizeObjective, recognizeExamNo, setHandleCopyInit, setHandleVerticalCopyVal, bindThis }
